/**
 * Centralize console logging for removal during compression to avoid dev console output
 * log array input as title / body to permit bold type, emojis, etc...
 *
 * @param args
 */
const debug = (...args) => {
  for (let argument of args) {
    if (Array.isArray(argument)) {
      console.log(argument[0], argument[1]);
    } else {
      console.log(argument);
    }
  }
};

/**
 * Log an event stub
 *
 * @param {String} type (notice|warning|error)
 * @param {String} emitter the name of the js file calling
 * @param {String} desc a brief description of the issue
 * @param {String} userId the affected userId, if provided
 */
const logEvent = (type, emitter, desc, userId = null) => {
  const types = ["notice", "warning", "error"];

  if (type && types.includes(type) && emitter) {
    const data = {
      "date": (Date.UTC() / 1000),
      "type": type,
      "emitter": emitter,
    };
    if (desc) {
      data["desc"] = desc;
    }
    if (userId) {
      data["userId"] = userId;
    }
    debug(["Log event:", data]);
  }
};

export {logEvent};

export default debug;
